import { Component, OnInit, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { MrpScrolltopComponent } from '../../services/mrp-scrolltop/mrp-scrolltop.component';
import { RouterLink } from '@angular/router';
import { FooterComponent } from '../../footer/footer.component';

@Component({
    selector: 'app-michigangop',
    templateUrl: './michigangop.component.html',
    styleUrls: ['./michigangop.component.css'],
    imports: [MrpScrolltopComponent, RouterLink, FooterComponent]
})
export class MichiganGOPComponent implements OnInit {
  isBrowser = false;
  constructor(private http: HttpClient, @Inject(PLATFORM_ID) private platformId: Object) { 
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  ngOnInit(): void {
    if (this.isBrowser) this.logPage('michigangop');
  }

  logPage(urlName: string): void {
    if (!this.isBrowser) return;
    this.http.post('/api/access/access_log.php', {urlName: urlName}).subscribe();
  }


}
